import { useCallback, useState } from "react";
import { useStore } from "../../context/StoreContext";
import { useToast } from "../../context/ToastContext";
import { Endpoint } from "../../api/base";
import { CaseDataResponse, Subject } from "../../types/CaseTypes";

// 2. Custom Hook for API (uses context internally)
export const useCaseApi = (caseId: string) => {
  const { setData, setFiles } = useStore();
  const [isLoading, setIsLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const { showToast } = useToast();

  const fetchCase = useCallback(async () => {
    try {
      setIsLoading(true);
      const res = await Endpoint.getCase(caseId);

      // Your data processing logic
      const processedData = processRawCaseData(res.data);

      setData(processedData);
    } catch (err) {
      showToast("Failed to load case data", "error");
    } finally {
      setIsLoading(false);
    }
  }, [caseId]);

  const saveCase = useCallback(async (values: CaseDataResponse) => {
    try {
      setOpen(true);
      await Endpoint.OccuTraceSaveCase(JSON.stringify(values));
      setData(values);
      setOpen(false);
      showToast("Data updated successfully", "success");
    } catch (err) {
      setOpen(false);
      showToast("Failed to save changes", "error");
    }
  }, []);

  const fetchFiles = useCallback(async () => {
    try {
      const res = await Endpoint.getFiles({ key: caseId });
      setFiles(res.data);
    } catch (err) {
      console.error("Error fetching files:", err);
    }
  }, [caseId]);

  return { fetchCase, saveCase, fetchFiles, loaderState: isLoading, open };
};

const processRawCaseData = (caseData: CaseDataResponse) => {
  // let res = {}
  //   caseData.case_detail.by_status = true;

  ///Handling edge cases because backend do not returns the below mention fields on first get

  if (!caseData.case_detail.case_details.tasks) {
    caseData.case_detail.case_details.tasks = [];
  }

  if (!caseData.case_detail.case_details.field_resource_information) {
    caseData.case_detail.case_details.field_resource_information = [
      {
        id: "",
        date_hired: "",
        due_date: "",
        hours_authorized: 0,
        hours_billed: 0,
        miles_billed: 0,
        database_billed: 0,
        report_received_date: "",
        invoice_received_date: "",
        invoice_approved_date: "",
        rating: 0,
        type: "",
      },
    ];
  }

  //check for budget field
  if (!caseData.case_detail.case_details.budget_information) {
    caseData.case_detail.case_details.budget_information = {
      scheduled: 0,
      used: 0,
    };
    if (caseData.case_detail.case_details.client_information.budget) {
      caseData.case_detail.case_details.budget_information.scheduled =
        caseData.case_detail.case_details.client_information.budget;
    }
  }

  //check for faulty relationship Array
  caseData.case_detail.case_details.Subjects_information.forEach(
    (val: Subject, key: number) => {
      if (typeof val.phone === "string") {
        val.phone = [val.phone];
      } else if (val.phone instanceof String) {
        val.phone = [val.phone.toString()];
      } else if (!Array.isArray(val.phone)) {
        val.phone = [""];
      }
      if (!val.email) val.email = [""];
      if (val.subject_type === "business") return;
      if (!Array.isArray(val.relationship)) {
        let tmp = val.relationship;
        val.relationship = [tmp];
      }
      try {
        val.relationship.forEach((i, k) => {
          if (!i.subjectIndex) {
            i.subjectIndex =
              caseData.case_detail.case_details.Subjects_information.findIndex(
                (x: Subject) => {
                  return i.subjectId === x.subject_id;
                }
              );
          }
        });
      } catch {}
    }
  );
  return caseData;
};
